export default "__VITE_ASSET__H0ZDOM3f__"